const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var DeliveryNote24 = function DeliveryNote24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 9V20C20 20.7956 19.6839 21.5587 19.1213 22.1213C18.5587 22.6839 17.7956 23 17 23H7C6.20435 23 5.44129 22.6839 4.87868 22.1213C4.31607 21.5587 4 20.7956 4 20V4C4 3.20435 4.31607 2.44129 4.87868 1.87868C5.44129 1.31607 6.20435 1 7 1H12V8C12 8.26522 12.1054 8.51957 12.2929 8.70711C12.4804 8.89464 12.7348 9 13 9H20ZM20 7H14V1L20 7ZM11.7841 18.6866L15.7841 13.6866C15.823 13.6452 15.8584 13.6008 15.8901 13.5536C16.0369 13.3327 16.0899 13.0625 16.0375 12.8025C15.9851 12.5425 15.8315 12.3139 15.6106 12.1671C15.3897 12.0203 15.1195 11.9673 14.8595 12.0197C14.5994 12.0721 14.3709 12.2257 14.2241 12.4466L10.9241 16.5666L9.71409 15.3566C9.52579 15.1683 9.27039 15.0625 9.00409 15.0625C8.73779 15.0625 8.4824 15.1683 8.29409 15.3566C8.10579 15.5449 8 15.8003 8 16.0666C8 16.3329 8.10579 16.5883 8.29409 16.7766L10.2941 18.7766C10.3875 18.8693 10.4983 18.9426 10.6202 18.9924C10.742 19.0422 10.8725 19.0674 11.0041 19.0666H11.0641C11.2041 19.0578 11.3407 19.0193 11.4648 18.9538C11.5889 18.8883 11.6977 18.7972 11.7841 18.6866Z",
      fill: "currentColor",
    })
  );
};
DeliveryNote24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: DeliveryNote24,
};
export function DeliveryNote(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'DeliveryNote' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
